// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import assessmentReducer from "./assessmentsSlice";
import userReducer from "./userSlice";
import attemptsReducer from "./attemptsSlice";

const store = configureStore({
    reducer: {
        assessments: assessmentReducer, // Add assessment slice reducer to the store
        users: userReducer, // Add user slice reducer to the store
        attempts: attemptsReducer, // Add user slice reducer to the store
    },
});

export default store;
